<ng-container *transloco="let t">
    <div class="auth-container">
        <div class="button-container">
            <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="layout">
            <div class="welcome">
                <mat-icon
                    [svgIcon]="'lps-sign-up'"
                    class="sign-up-icon"
                ></mat-icon>
                <h1>{{ t("auth.sign-in.header") }}</h1>
                <p>
                    {{ t("auth.sign-in.explanation") }}
                </p>
                <p>
                    <small>
                        {{ t("auth.sign-in.accountQuestion") }}
                        <a
                            [routerLink]="[
                                '',
                                { outlets: { auth: ['sign-up'] } }
                            ]"
                            [skipLocationChange]="true"
                            >{{ t("auth.sign-in.signUp") }}</a
                        >
                    </small>
                </p>
            </div>
            <div class="stepper-container">
                <app-account-stepper>
                    <cdk-step>
                        <app-login
                            [busy]="loginBusy"
                            (emailOrPhoneProvided)="
                                emailOrPhoneProvided($event)
                            "
                        ></app-login>
                    </cdk-step>

                    <cdk-step>
                        <app-account-verification
                            [header]="t('auth.sign-in.appVerificationHeader')"
                            (codeProvided)="codeProvided($event)"
                            (back)="goBack()"
                        ></app-account-verification>
                    </cdk-step>
                </app-account-stepper>
            </div>
        </div>
    </div>
</ng-container>
